@let uc = useCase();

@if (uc) {
  <!-- HERO -->
  <htx-hero-section
    [title]="uc.titleKey | transloco"
    [subtitle]="uc.subtitleKey | transloco"
    [metaItems]="heroMetaItems()"
    [flatBottom]="true">
  </htx-hero-section>

  <!-- PAGE NAV (sticky) -->
  <nav class="hero-nav">
    @for (item of pageNavItems(); track item.targetId) {
      <a href="javascript:void(0)" (click)="scrollTo(item.targetId)">
        <htx-icon [icon]="item.icon"></htx-icon>
        {{ item.label }}
      </a>
    }
  </nav>

  <!-- CONTENT -->
  <div class="detail-content">

    <!-- BESCHREIBUNG -->
    <div class="section" id="beschreibung">
      <h3 class="section-title">
        <htx-icon icon="description"></htx-icon>
        {{ 'usecases.sections.descriptionTitle' | transloco }}
      </h3>
      <div class="description-text" [innerHTML]="uc.descriptionKey | transloco"></div>
    </div>

    <!-- ROLLEN -->
    <div class="section" id="rollen">
      <h3 class="section-title">
        <htx-icon icon="people"></htx-icon>
        {{ 'usecases.sections.rolesTitle' | transloco }}
      </h3>
      <htx-info-card-grid [cards]="roleCards()" variant="card"></htx-info-card-grid>
    </div>

    <!-- SOFTWARE -->
    <div class="section" id="software">
      <h3 class="section-title">
        <htx-icon icon="integration_instructions"></htx-icon>
        {{ 'usecases.sections.softwareTitle' | transloco }}
      </h3>
      <htx-info-card-grid [cards]="softwareCards()" variant="list"></htx-info-card-grid>
    </div>

    <!-- VORAUSSETZUNGEN -->
    <div class="section" id="voraussetzungen">
      <h3 class="section-title">
        <htx-icon icon="checklist"></htx-icon>
        {{ 'usecases.sections.prerequisitesTitle' | transloco }}
      </h3>
      <htx-checklist [items]="prerequisiteItems()"></htx-checklist>
    </div>

    <!-- SCREENSHOTS -->
    <div class="section" id="screenshots">
      <h3 class="section-title">
        <htx-icon icon="image"></htx-icon>
        {{ 'usecases.sections.screenshotsTitle' | transloco }}
      </h3>
      <div class="screenshots-grid">
        @for (screenshot of uc.screenshots; track screenshot.caption) {
          <div class="screenshot-card">
            <div class="screenshot-placeholder">
              <htx-icon icon="monitor"></htx-icon>
              <span>{{ screenshot.placeholder | transloco }}</span>
            </div>
            <div class="caption">{{ screenshot.caption | transloco }}</div>
          </div>
        }
      </div>
    </div>

    <!-- FAQ -->
    <div class="section" id="faq">
      <h3 class="section-title">
        <htx-icon icon="help_outline"></htx-icon>
        {{ 'usecases.sections.faqTitle' | transloco }}
      </h3>
      <htx-faq-accordion [items]="faqItems()"></htx-faq-accordion>
    </div>

    <!-- CTA -->
    <htx-cta-section
      [title]="'usecases.cta.title' | transloco"
      [description]="'usecases.cta.description' | transloco">
      @if (!isLoggedIn.value) {
        <htx-button variant="secondary" icon="how_to_reg" [disabled]="true">
          {{ 'usecases.cta.buttonLoginRequired' | transloco }}
        </htx-button>
      } @else if (orgNotApproved()) {
        <htx-button variant="secondary" icon="block" [disabled]="true">
          {{ 'usecases.cta.orgNotApproved' | transloco }}
        </htx-button>
      } @else if (orgInactive()) {
        <htx-button variant="secondary" icon="block" [disabled]="true">
          {{ 'usecases.cta.orgInactive' | transloco }}
        </htx-button>
      } @else if (participationState() === AdmissionState.APPROVED) {
        <htx-button variant="secondary" icon="check_circle" [disabled]="true">
          {{ 'usecases.cta.statusApproved' | transloco }}
        </htx-button>
      } @else if (participationState() === AdmissionState.REJECTED) {
        <htx-button variant="secondary" icon="cancel" [disabled]="true">
          {{ 'usecases.cta.statusRejected' | transloco }}
        </htx-button>
      } @else if (participationState() === AdmissionState.PENDING) {
        <htx-button variant="secondary" icon="hourglass_top" [disabled]="true">
          {{ 'usecases.cta.statusPending' | transloco }}
        </htx-button>
      } @else if (statusLoading()) {
        <htx-button variant="secondary" icon="hourglass_empty" [disabled]="true">
          {{ 'usecases.cta.button' | transloco }}
        </htx-button>
      } @else if (statusError()) {
        <htx-button variant="secondary" icon="error_outline" [disabled]="true">
          {{ 'usecases.cta.button' | transloco }}
        </htx-button>
      } @else {
        <htx-button variant="secondary" icon="how_to_reg" (click)="onRequestParticipation()" [disabled]="requestInProgress()">
          {{ 'usecases.cta.button' | transloco }}
        </htx-button>
      }
    </htx-cta-section>
  </div>
}
